export const css = {
	root: '_1oO3hbt6',
	question: 'SlxwZvDn',
	feedback: '_1SNjbgoj',
	rationale: 'cCu42l4N',
	fmi: 'cDGvKSmf',
	distractorBlock: '_3Xtbeyft',
	distractorFieldset: '_2MUeXQYz',
	distractorLegend: '_3Oqz9d2m',
	distractor: '_2kn9Y42R',
	distractorLabel: '_1SRpA42p',
	distractorWithFlag: '_14ztujYN',
	distractorHint: '_2DA_paxo',
	actions: '_3KS5ieJ-',
	oneaction: 'DiUJNXEl',
	markblock: 'DqVGlyxi',
	timerblock: '_10zh50yA',
	timer: '_2eJK2TcM',
	' _key': 'certwise-theme/certwise/quiz-widgets/mcquestion'
};

export default css;
